module.exports = __webpack_public_path__ + "wheelchair.jpg?99d98343d9df458fdc427d92f01e2474";